export default __webpack_public_path__ + "static/media/813.66b6a183.png";